import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Défis',
    lead: 'Organisez des défis d’équipe : pas, sommeil, entraînements et plus, avec un classement optionnel.',
    noCompany: 'Sélectionnez une entreprise pour voir ses défis.',
    forbidden: 'Vous n’avez pas accès aux défis de cette entreprise.',
    empty: 'Aucun défi pour l’instant — créez le premier.',
  },
  counts: {
    active: 'Défis actifs',
    draft: 'Brouillons',
    completed: 'Terminés',
    totalParticipants: 'Participants au total',
  },
  sections: {
    activePublished: 'Actifs & publiés',
    draftsCompleted: 'Brouillons & terminés',
  },
  card: {
    type: 'Type',
    mode: 'Format',
    period: 'Période',
    goal: 'Objectif',
    reward: 'Récompense',
    participants: 'Participants',
    engagement: 'Engagement',
    completion: "Taux d'achèvement",
    leaderboardVisible: 'Classement visible',
    leaderboardHidden: 'Classement masqué',
  },
  mode: {
    individual: 'Individuel',
    group: 'Équipe',
  },
  status: {
    draft: 'Brouillon',
    active: 'Actif',
    paused: 'En pause',
    completed: 'Terminé',
  },
  type: {
    steps: 'Pas',
    sleep: 'Sommeil',
    workouts: 'Entraînements',
    meditation: 'Méditation',
    custom: 'Personnalisé',
  },
  actions: {
    newChallenge: 'Nouveau défi',
    publish: 'Publier',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    finish: 'Terminer',
    duplicate: 'Dupliquer en brouillon',
    duplicateSuffix: 'copie',
    viewLeaderboard: 'Voir le classement',
    hideLeaderboard: 'Masquer le classement',
  },
  leaderboard: {
    title: 'Classement',
    empty: 'Aucun participant pour l’instant.',
  },
  form: {
    title: 'Nouveau défi',
    submit: 'Créer le défi',
    cancel: 'Annuler',
    fields: {
      title: 'Titre',
      description: 'Description',
      type: 'Type',
      mode: 'Format',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      goalValue: 'Valeur cible',
      unit: 'Unité',
      reward: 'Récompense',
      leaderboardVisible: 'Afficher le classement aux participants',
    },
    errors: {
      required: 'Ce champ est obligatoire.',
      endBeforeStart: 'La date de fin ne peut pas précéder la date de début.',
    },
  },
};
